/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Arbeitserlaubnisid2Inputs */



/**

* @param {_Field_Arbeitserlaubnisid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_arbeitserlaubnisid2 = /** @type {((inputs?: _Field_Arbeitserlaubnisid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Arbeitserlaubnisid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kopie Arbeitserlaubnis")
});
export { _field_arbeitserlaubnisid2 as "_field_arbeitserlaubnisID" }